import React, { useState, useEffect } from "react";
import Logo from "../navbar/Logo";
import DesktopNavigation from "../navbar/DesktopNavigation";
import MobileMenu from "../navbar/MobileMenu";
import MobileNavButton from "../navbar/MobileNavButton";
import useScrollEffect from "../navbar/useScrollEffect";
import { scrollToSection } from "@/utils/scrollUtils";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isScrolled, scrollDirection } = useScrollEffect();

  // Close mobile menu when scrolling down
  useEffect(() => {
    if (scrollDirection === "down" && isOpen) {
      setIsOpen(false);
    }
  }, [scrollDirection, isOpen]);

  // Close mobile menu with Escape key
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [isOpen]);

  // Helper function for scroll navigation
  const handleScrollToSection = (sectionId: string) => {
    setIsOpen(false); // Close mobile menu if open
    scrollToSection(sectionId);
  };

  return (
    <nav
      aria-label="Navegación principal"
      className={`fixed top-0 left-0 right-0 z-50 bg-background/90 backdrop-blur-md border-b border-border transition-transform duration-300 md:translate-y-0 ${
        isScrolled ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-14 md:h-16 gap-6">
          <Logo isScrolled={isScrolled} />
          <DesktopNavigation scrollToSection={handleScrollToSection} isScrolled={isScrolled} />
          <div className="md:hidden">
            <MobileNavButton isOpen={isOpen} setIsOpen={setIsOpen} />
          </div>
        </div>
      </div>

      <MobileMenu isOpen={isOpen} scrollToSection={handleScrollToSection} />
    </nav>
  );
};

export default Navbar;

